import { render, staticRenderFns } from "./SendDebitorDocuemntMailBtn.vue?vue&type=template&id=1fd6be80&"
import script from "./SendDebitorDocuemntMailBtn.vue?vue&type=script&lang=js&"
export * from "./SendDebitorDocuemntMailBtn.vue?vue&type=script&lang=js&"
import style0 from "./SendDebitorDocuemntMailBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports